import React, { useState, useEffect, useRef } from 'react';

const Worked = () => {
  const [mousePosition, setMousePosition] = useState({ x: 50, y: 50 });
  const [isHovering, setIsHovering] = useState(false);
  const svgRef = useRef<SVGSVGElement>(null);

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (isHovering && svgRef.current) {
        const rect = svgRef.current.getBoundingClientRect();
        // Calculate relative position within the SVG (0-100%)
        const x = Math.max(
          0,
          Math.min(100, ((e.clientX - rect.left) / rect.width) * 100),
        );
        const y = Math.max(
          0,
          Math.min(100, ((e.clientY - rect.top) / rect.height) * 100),
        );
        setMousePosition({ x, y });
      }
    };

    document.addEventListener('mousemove', handleMouseMove);
    return () => document.removeEventListener('mousemove', handleMouseMove);
  }, [isHovering]);

  const handleMouseEnter = () => setIsHovering(true);
  const handleMouseLeave = () => setIsHovering(false);

  return (
    <div className="flex h-96 items-center justify-center">
      <svg
        ref={svgRef}
        width="100%"
        height="100%"
        viewBox="0 0 300 100"
        xmlns="http://www.w3.org/2000/svg"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={{
          userSelect: 'none',
          WebkitUserSelect: 'none',
          MozUserSelect: 'none',
          msUserSelect: 'none',
        }}
      >
        <defs>
          {/* Beautiful gradient for the text - using actual colors */}
          <linearGradient
            id="textGradient"
            gradientUnits="userSpaceOnUse"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="100%"
          >
            <stop offset="0%" stopColor="#3b82f6" />
            <stop offset="25%" stopColor="#8b5cf6" />
            <stop offset="50%" stopColor="#f59e0b" />
            <stop offset="75%" stopColor="#3b82f6" />
            <stop offset="100%" stopColor="#8b5cf6" />
          </linearGradient>

          {/* Soft mouse-following spotlight mask with gradient falloff */}
          <mask id="textMask" className="hidden lg:block">
            {/* Background - black (text hidden everywhere) */}
            <rect x="0" y="0" width="100%" height="100%" fill="black" />
            {/* Soft spotlight - white to black gradient (text visible to hidden) */}
            <radialGradient
              id="softSpotlight"
              gradientUnits="userSpaceOnUse"
              r="20%"
              cx={`${mousePosition.x}%`}
              cy={`${mousePosition.y}%`}
            >
              <stop offset="0%" stopColor="white" />
              <stop offset="30%" stopColor="white" />
              <stop offset="60%" stopColor="rgba(255,255,255,0.5)" />
              <stop offset="100%" stopColor="black" />
            </radialGradient>
            {/* Apply the soft spotlight gradient */}
            <circle
              cx={`${mousePosition.x}%`}
              cy={`${mousePosition.y}%`}
              r="20%"
              fill="url(#softSpotlight)"
            />
          </mask>

          {/* Alternative: Linear sweep mask - creates a wave effect */}
          <linearGradient
            id="sweepMask"
            gradientUnits="userSpaceOnUse"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="0%"
          >
            <stop offset="0%" stopColor="black" />
            <stop offset="40%" stopColor="black" />
            <stop offset="50%" stopColor="white" />
            <stop offset="60%" stopColor="white" />
            <stop offset="100%" stopColor="black" />
          </linearGradient>

          {/* Diagonal reveal mask */}
          <linearGradient
            id="diagonalMask"
            gradientUnits="userSpaceOnUse"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="100%"
          >
            <stop offset="0%" stopColor="white" />
            <stop offset="50%" stopColor="white" />
            <stop offset="100%" stopColor="black" />
          </linearGradient>

          {/* Alternative masks for different effects */}
          <mask id="sweepTextMask">
            <rect
              x="0"
              y="0"
              width="100%"
              height="100%"
              fill="url(#sweepMask)"
            />
          </mask>

          <mask id="diagonalTextMask">
            <rect
              x="0"
              y="0"
              width="100%"
              height="100%"
              fill="url(#diagonalMask)"
            />
          </mask>
        </defs>

        {/* Background text - always visible */}
        <text
          x="50%"
          y="50%"
          textAnchor="middle"
          dominantBaseline="middle"
          strokeWidth="0.3"
          className="stroke-muted/30 antonio fill-transparent text-4xl leading-0 font-bold"
          style={{
            userSelect: 'none',
            WebkitUserSelect: 'none',
            MozUserSelect: 'none',
            msUserSelect: 'none',
          }}
          pointerEvents="none"
        >
          Worked For
        </text>

        {/* Middle layer - subtle glow */}
        <text
          x="50%"
          y="50%"
          textAnchor="middle"
          dominantBaseline="middle"
          strokeWidth="0.3"
          className="stroke-primary/20 antonio fill-transparent text-4xl leading-0 font-bold"
          style={{
            userSelect: 'none',
            WebkitUserSelect: 'none',
            MozUserSelect: 'none',
            msUserSelect: 'none',
          }}
          pointerEvents="none"
        >
          Worked For
        </text>

        {/* Main masked text with gradient - uses mouse-following spotlight */}
        <text
          x="50%"
          y="50%"
          textAnchor="middle"
          dominantBaseline="middle"
          stroke="url(#textGradient)"
          strokeWidth="0.3"
          fill="transparent"
          mask="url(#textMask)"
          className="antonio text-4xl leading-0 font-bold"
          style={{
            userSelect: 'none',
            WebkitUserSelect: 'none',
            MozUserSelect: 'none',
            msUserSelect: 'none',
          }}
        >
          Worked For
        </text>
      </svg>
    </div>
  );
};

export default Worked;
